import React, { useState } from 'react';
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

function MultiFileUploadWithBottomProgressBar({
  backendId,
  getSelectedFolderPath,
  openAlertPopup,
  get_details_of_backends,
  getPathkey,
  handleCloseModal
}) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const selectedPath = getSelectedFolderPath();
    setFiles([...files, ...selectedFiles]);
    e.target.value = '';

    setUploading(true);

    // Actual upload logic (uncomment for use)
    const uploadPromises = selectedFiles.map((file) => uploadFile(file));
    try {
      await Promise.all(uploadPromises);
      const pathKey = getPathkey(getSelectedFolderPath())
      get_details_of_backends(backendId, 1, selectedPath, pathKey);
      openAlertPopup("Success", "Files are Uploaded!!!");
      handleCloseModal();
      setFiles([]);
    } catch (error) {
      openAlertPopup("Error", `Error uploading files: ${error}`);
    } finally {
      setUploading(false);
    }
  };

  const uploadFile = async (file) => {
    const selectedPath = getSelectedFolderPath()
    const url = '/api/v1/file_ops/upload/' + backendId + '/' + selectedPath.replace(/\//g, "%2F");
    const formData = new FormData();
    formData.append('files', file);

    try {
      const response = await axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  function GradientCircularProgress() {
    return (
      <>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
      </>
    );
  }

  return (
    <div className="upload-form-container">
      {uploading && (
        <div className="upload-overlay">
          <div className="uploading-text">Uploading files...</div>
          <GradientCircularProgress />
        </div>
      )}

      <label htmlFor="upload" className="upload-drop-area">
        <FontAwesomeIcon icon={faUpload} className="upload-icon" />
        <span className="upload-label">Click or drag files here to upload</span>
        <input type="file" id="upload" multiple hidden onChange={handleFileChange} disabled={uploading} />
      </label>

      {files.length > 0 && (
        <div className="file-preview">
          <strong>Selected Files:</strong>
          <ul>
            {files.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default MultiFileUploadWithBottomProgressBar;
